import {$, w} from './constants';
import { trackEvent } from "./gtm.js"; 

// Advisory Chatbot
$('[href="#chatbot"]').click(function (e) {
	e.preventDefault()
	chatbot()
	$('.chatbot_iframe_JS').show()
})
$('.chatbot_btn_JS').click(function () {
	chatbot()
	$('.chatbot_iframe_JS').show()
})
$('.chatbot_close_JS').click(function () {
	$('.chatbot_btn_JS').hide()
	$('.chatbot_iframe_JS').hide()
})
$('.chatbot_min_JS').click(function () {
	$('.chatbot_btn_JS').show()
	$('.chatbot_iframe_JS').hide()
})
$('.chatbot_utm_JS .btn').click(function(e) {
	e.preventDefault();
})

// Chatbot iframe UTMs
function chatbot() {

	// MODE 1: chatbot button exists
	if ($('.chatbot_utm_JS').length) {

		const $this = $('.chatbot_utm_JS .btn');
		if (!$this.length) return;

		const utmMediumAttr = $this.data('utm-medium');
		const utmSourceAttr = $this.data('utm-source');
		const utmCampaignAttr = $this.data('utm-campaign');

		const currentParams = new URLSearchParams(window.location.search);

		const currentId = $this.attr('id') || '';
		const utmMediumDynamic = utmMediumAttr
			? (currentId ? `${utmMediumAttr}_${currentId}` : utmMediumAttr)
			: null;

		const defaults = {
			utm_source: 'sitio-web',
			utm_medium: 'cta',
			utm_campaign: 'trafico-directo'
		};

		const finalParams = new URLSearchParams();

		currentParams.forEach((value, key) => {
			finalParams.set(key, value);
		});

		if (!finalParams.has('utm_source') && utmSourceAttr) {
			finalParams.set('utm_source', utmSourceAttr);
		}

		if (!finalParams.has('utm_medium') && utmMediumDynamic) {
			finalParams.set('utm_medium', utmMediumDynamic);
		}

		if (!finalParams.has('utm_campaign') && utmCampaignAttr) {
			finalParams.set('utm_campaign', utmCampaignAttr);
		}

		Object.entries(defaults).forEach(([key, value]) => {
			if (!finalParams.has(key)) {
				finalParams.set(key, value);
			}
		});

		const baseSrc = $('.chatbot_element_JS').attr('data-src')
			|| $('.chatbot_element_JS').attr('data-lazy-src');

		if (!baseSrc) return;

		$('.chatbot_element_JS').attr('src', '');

		const url = new URL(baseSrc, window.location.origin);

		finalParams.forEach((value, key) => {
			url.searchParams.set(key, value);
		});

		$('.chatbot_element_JS').attr('src', url.toString());
		return;
	}

	// MODE 2: single post wrapper exists
	if ($('.single_blog_advisory_JS').length) {

		const $wrapper = $('.single_blog_advisory_JS');
		const slug = $wrapper.data('slug');

		const currentParams = new URLSearchParams(window.location.search);

		const defaults = {
			utm_medium: 'cta',
			utm_source: 'blog',
			utm_campaign: slug
		};

		const finalParams = new URLSearchParams(currentParams.toString());

		Object.entries(defaults).forEach(([key, value]) => {
			if (!finalParams.has(key)) {
				finalParams.set(key, value);
			}
		});

		const baseSrc = $('.chatbot_element_JS').attr('data-src')
			|| $('.chatbot_element_JS').attr('data-lazy-src');

		if (!baseSrc) return;

		$('.chatbot_element_JS').attr('src', '');

		const url = new URL(baseSrc, window.location.origin);

		finalParams.forEach((value, key) => {
			url.searchParams.set(key, value);
		});

		$('.chatbot_element_JS').attr('src', url.toString());
		return;
	}

	// MODE 3: original secondary mode (no chatbot, no single post)
	const baseSrc = $('.chatbot_element_JS').attr('data-src')
		|| $('.chatbot_element_JS').attr('data-lazy-src');

	if (!baseSrc) return;

	$('.chatbot_element_JS').attr('src', '');

	const url = new URL(baseSrc, window.location.origin);
	const currentParams = new URLSearchParams(window.location.search);

	const defaults = {
		utm_source: 'sitio-web',
		utm_medium: 'cta',
		utm_campaign: 'trafico-directo'
	};

	const finalParams = new URLSearchParams();

	currentParams.forEach((value, key) => {
		finalParams.set(key, value);
	});

	Object.entries(defaults).forEach(([key, value]) => {
		if (!finalParams.has(key)) {
			finalParams.set(key, value);
		}
	});

	finalParams.forEach((value, key) => {
		url.searchParams.set(key, value);
	});

	$('.chatbot_element_JS').attr('src', url.toString());
}
